import React from 'react';
import { Button } from '@mui/material';
import TitanDialog from '../Titan/TitanDialog';
import Alert from '@mui/material/Alert';
import { makeStyles } from '@mui/styles';
const FileDownload = require('js-file-download');

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  config: {
    margin: theme.spacing(2, 0),

    '& > p': {
      margin: 0,
    },
  },
  certificates: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(2, 0),
  },
}));

export default function LabelPrinterConfigDialog({
  onClose,
  labelPrinterConfig,
}) {
  const classes = useStyles();

  const downloadCertificate = () => {
    FileDownload(
      labelPrinterConfig.certificate.certificateData,
      labelPrinterConfig.certificate.certificateFileName,
    );
  };

  const downloadPrivateKey = () => {
    FileDownload(
      labelPrinterConfig.certificate.privateKeyData,
      labelPrinterConfig.certificate.privateFileName,
    );
  };

  const downloadPublicKey = () => {
    FileDownload(
      labelPrinterConfig.certificate.publicKeyData,
      labelPrinterConfig.certificate.publicFileName,
    );
  };

  return (
    <TitanDialog
      onClose={onClose}
      maxWidth="md"
      title="Label Printer config file"
      cancelButtonLabel="Close"
    >
      <div className={classes.container}>
        <Alert severity="info">
          Copy next config to .env file of label printer
        </Alert>

        <div className={classes.config}>
          <p>
            <b>LABEL_PRINTER_ID</b>={labelPrinterConfig.labelPrinterId}
          </p>
          <p>
            <b>IOT_THING_NAME</b>={labelPrinterConfig.iotThingName}
          </p>
          <p>
            <b>AWS_HOST</b>={labelPrinterConfig.awsHost}
          </p>
          <p>
            <b>AWS_REGION</b>={labelPrinterConfig.awsRegion}
          </p>
        </div>

        <Alert severity="info">
          Download certificate and key files. You will not able to download
          after close this dialog
        </Alert>

        <div className={classes.certificates}>
          <Button
            variant="outlined"
            color="primary"
            onClick={downloadCertificate}
          >
            certificate.pem.crt
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={downloadPrivateKey}
          >
            private.pem.key
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={downloadPublicKey}
          >
            public.pem.key
          </Button>
        </div>
      </div>
    </TitanDialog>
  );
}
